import { render, staticRenderFns } from "./contentofferedjob.vue?vue&type=template&id=11f4d5b8"
import script from "./contentofferedjob.vue?vue&type=script&lang=js"
export * from "./contentofferedjob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports